"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropertyPath = void 0;
const react_1 = require("react");
const utils_1 = require("../../utils");
const usePropertyPath = (path) => {
    return (0, react_1.useMemo)(() => {
        try {
            return {
                pathSegments: path ? (0, utils_1.getPropertyPathSegments)(path) : [],
            };
        }
        catch (error) {
            // Syntax of the property path is incorrect.
            return {
                error,
            };
        }
    }, [path]);
};
exports.usePropertyPath = usePropertyPath;
//# sourceMappingURL=usePropertyPath.js.map